import throttle from 'lodash.throttle';
import barba from '@barba/core';
import anime from 'animejs';

export default class NextChapterOverlay {
	static create(chapter) {
		const nextChapterElement = chapter.container.querySelector('[data-next-chapter]');

		if (!nextChapterElement) {
			return null;
		}

		return new NextChapterOverlay(nextChapterElement, chapter);
	}

	constructor(el, chapter) {
		this.el = el;
		this.chapter = chapter;
		this.countDownTimer = null;
		this.url = this.el.dataset.nextChapter;
		this.countDownElement = this.el.querySelector('[data-next-chapter-count-down]');
		this.progressBar = this.el.querySelector('[data-next-chapter-progress-bar]');

		this.boundHandleScroll = throttle(this.handleScroll.bind(this), 50);
		document.addEventListener('scroll', this.boundHandleScroll);
	}

	handleScroll() {
		if (!this.chapter.lastChapterPartActive) {
			return;
		}

		const scrollDistance = document.documentElement.clientHeight;
		const fullScrollHeight = window.scrollY + scrollDistance;
		let percentage = 0;

		if (fullScrollHeight >= document.documentElement.scrollHeight - scrollDistance) {
			percentage = 100 - ((document.documentElement.scrollHeight - fullScrollHeight) / scrollDistance) * 100;
			this.show();
		} else {
			percentage = 0;
			this.hide();
		}

		this.el.style.setProperty('--next-chapter-scroll-progress', `${percentage}%`);
	}

	get isActive() {
		return this.el.classList.contains('is-active');
	}

	goToNextChapter() {
		barba.go(this.url);
	}

	countDown(timeleft) {
		return new Promise((resolve, reject) => {
			anime.remove(this.progressBar);

			anime({
				targets: this.progressBar,
				duration: timeleft*1000,
				scaleX: [0, 1],
				easing: 'linear',
				begin: () => {
					this.progressBar.style.transformOrigin = 'left';
				},
			});

			this.countDownElement.innerText = `Playing in ${timeleft}…`;

			this.countDownTimer = setInterval(() => {
				timeleft--;

				this.countDownElement.innerText = `Playing in ${timeleft}…`;

				if (timeleft <= 0) {
					clearInterval(this.countDownTimer);
					anime({
						targets: this.progressBar,
						duration: 1000,
						easing: 'easeInOutCubic',
						scaleX: [1, 0],
						begin: () => {
							this.progressBar.style.transformOrigin = 'right';
							this.el.classList.remove('is-active');
						},
						complete: () => {
							resolve(true);
						}
					});
				}
			}, 1000);
		});
	}

	async show() {
		if (this.isActive) {
			return;
		}

		this.chapter.elm.classList.add('hide-header-ui');
		this.el.classList.add('is-active');

		if (this.chapter.audio) {
			this.chapter.audio.fadeOut(4000);
		}

		if (!this.countDownTimer) {
			await this.countDown(10);
			this.goToNextChapter();
		}
	}

	hide() {
		if (!this.isActive) {
			return;
		}

		this.chapter.elm.classList.remove('hide-header-ui');
		this.el.classList.remove('is-active');

		if (this.chapter.audio) {
			this.chapter.audio.fadeIn();
		}

		if (this.countDownTimer) {
			clearInterval(this.countDownTimer);
			this.countDownTimer = null;
		}
	}

	destroy() {
		document.removeEventListener('scroll', this.boundHandleScroll);
		if (this.countDownTimer) {
			clearInterval(this.countDownTimer);
			this.countDownTimer = null;
		}
	}
}
